var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImageDropIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 44,
    viewBox: "0 0 58 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51.456 1.59082H6.54688C4.0616 1.59082 2.04688 3.60553 2.04688 6.09082V37.909C2.04688 40.3943 4.0616 42.409 6.54688 42.409H51.456C53.9412 42.409 55.956 40.3943 55.956 37.909V6.09082C55.956 3.60554 53.9412 1.59082 51.456 1.59082Z",
    stroke: "#0e0333",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.0339 16.2769L37.1438 17.2859L36.0338 16.2769L22.8317 30.7993C21.5147 32.248 19.2654 32.3346 17.8409 30.9915L13.4037 26.8079C12.6333 26.0814 11.4302 26.0814 10.6597 26.8079L2.67485 34.3364C2.27406 34.7143 2.04688 35.2408 2.04688 35.7916V37.9092C2.04688 40.3945 4.0616 42.4092 6.54688 42.4092H51.456C53.9412 42.4092 55.956 40.3945 55.956 37.9092V33.125C55.956 32.5741 55.7288 32.0477 55.328 31.6698L38.8858 16.1671C38.0717 15.3996 36.7864 15.4491 36.0339 16.2769Z",
    stroke: "#0e0333",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9401 18.1663C17.2413 18.1663 19.1068 16.3009 19.1068 13.9997C19.1068 11.6985 17.2413 9.83301 14.9401 9.83301C12.6389 9.83301 10.7734 11.6985 10.7734 13.9997C10.7734 16.3009 12.6389 18.1663 14.9401 18.1663Z",
    stroke: "#0e0333",
    strokeWidth: 3
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageDropIcon);
export default __webpack_public_path__ + "static/media/image-drop-icon.766cfee3faa7ce2e7a8dc9624e724fba.svg";
export { ForwardRef as ReactComponent };